import { JSX } from 'react';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';

export type S7ServicesSearchProps = RenderingProps<unknown, S7ServicesSearchParams>;

export type S7ServicesSearchParams = DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export const Default = (props?: S7ServicesSearchProps): JSX.Element => {
  return (
    <div
      className={`component ${props?.params?.styles} ${translationClasses(props?.params)}`}
      id={props?.params?.AnchorLinkTargetName}
    >
      <div className="component-content">
        <p>S7ServicesSearchProps Component</p>
      </div>
    </div>
  );
};
